// /src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from '../pages/Login';
import { AdminDashboard } from '../pages/admin/Dashboard';
import { Clientes } from '../pages/admin/Clientes';
import { Estandares } from '../pages/admin/Estandares';
import { Usuarios } from '../pages/admin/Usuarios';
import { Proyectos } from '../pages/Proyectos';
import { ProyectoDetalle } from '../pages/ProyectoDetalle';
import { Capacitacion } from '../pages/Capacitacion';
import { CursoDetalle } from '../pages/CursoDetalle';
import { ProtectedRoute } from './ProtectedRoute';
import { Layout } from '../components/layout/Layout';
import { useAuth } from '../hooks/useAuth';

export const AppRoutes: React.FC = () => {
  const { usuario } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <Layout>
              <AdminDashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/admin/clientes"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <Layout>
              <Clientes />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/admin/estandares"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <Layout>
              <Estandares />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/admin/usuarios"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <Layout>
              <Usuarios />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/proyectos"
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Consultor', 'Cliente']}>
            <Layout>
              <Proyectos />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/proyecto/:id"
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Consultor', 'Cliente']}>
            <Layout>
              <ProyectoDetalle />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/capacitacion"
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Consultor', 'Cliente']}>
            <Layout>
              <Capacitacion />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/capacitacion/:id"
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Consultor', 'Cliente']}>
            <Layout>
              <CursoDetalle />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/"
        element={
          usuario ? (
            <Navigate to={usuario.rol === 'Admin' ? '/admin/dashboard' : '/proyectos'} replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
